window.config = require('@config/config.js')
const CONFIG = new config()
const store = {
    namespaced: true,
    state: {
        customers: [],
        requester_node: null,
        requester_contract: null,
        operator_node: {},
        waybill_raw_datas: [],
        waybill_processed_datas: [],
        receivers: [],
        converters: [],
        current_converter: null,
        conversions: [],
        // urls
        open_file_url: null,
        file_upload_url: "https://air.formosaas.com/api/v1/:app_id/cloud/:access_token/:identity/bucket/:bucket_identity/upload",
        fetch_customers_url: null,
        fetch_converters_url: null,
        create_operation_url: null,
        use_waybill_url: null,
        validate_waybill_url: null,
        validator: "standard",
    },
    getters: {
    },
    actions: {
        set_urls(context, payload) {
            return new Promise(resolve => {
                var scope = context.rootState.current_scope
                // open_file_url
                context.commit(
                    'set_open_file_url',
                    context.rootState[scope].routes.api_v1_provider_file_converters_convert
                )
                // file_upload_url
                context.commit(
                    'set_file_upload_url',
                    new RestUrl(context.rootState[scope].uploader_module.file_upload_url).parse(
                        {
                            "app_id": context.rootState[scope].node.air_service.air_app_id,
                            "access_token": context.rootState[scope].node.air_service.air_access_token,
                            "identity": context.rootState[scope].node.air_service.air_identity,
                            "bucket_identity": context.rootState[scope].node.air_service.air_bucket_identity,
                            "air_authorization": context.rootState[scope].node.air_service.air_authorization
                        },
                        "?authorization=" + context.rootState[scope].node.air_service.air_authorization + "&is_froala=true"
                    )
                )
                // create_operation_url
                context.commit(
                    'set_create_operation_url',
                    context.rootState[scope].routes["api_v1_provider_operations_create"]
                )
                // use_waybill_url
                context.commit(
                    'set_use_waybill_url',
                    context.rootState[scope].routes["api_v1_provider_operation_use_core_waybill"]
                )
                // fetch_customers_url
                context.commit(
                    'set_fetch_customers_url',
                    context.rootState[scope].routes["api_v1_provider_customers"]
                )
                // set_validate_waybill_url
                context.commit(
                    'set_validate_waybill_url',
                    context.rootState[scope].routes["api_v1_provider_core_waybills_usable_core_waybills"]
                )
                // fetch_converters_url
                context.commit(
                    'set_fetch_converters_url',
                    context.rootState[scope].routes["api_v1_provider_file_converters"]
                )

                resolve()
            })
        },
        fetch_customers(context, payload) {
            var scope = context.rootState.current_scope
            var url = new RestUrl(context.state.fetch_customers_url).parse(
                {},
                "?" + object_to_query({
                    pagination: false,
                    is_banned: false,
                })
            )
            return axios.get(url, { headers: { Authorization: localStorage.getItem("authentication_token") }})
                .then(response => {
                    if (response.data.status == "success") {
                        context.commit('set_customers', response.data.customers)
                    } else if (response.data.status == "failure") {
                    }
                })
                .catch(error => {
                })
        },
        fetch_converters(context, payload) {
            var scope = context.rootState.current_scope
            return axios.get(context.state.fetch_converters_url, { headers: { Authorization: localStorage.getItem("authentication_token") }})
                .then(response => {
                    if (response.data.status == "success") {
                        context.commit('set_converters', response.data.converters)
                    } else if (response.data.status == "failure") {
                    }
                })
                .catch(error => {
                })
        },
        fetch_operator_node(context, payload) {
            context.commit('set_operator_node', context.rootState.provider.node)
        },
    },
    mutations: {
        set_open_file_url(state, payload) {
            state.open_file_url = payload
        },
        set_file_upload_url(state, payload) {
            state.file_upload_url = payload
        },
        set_create_operation_url(state, payload) {
            state.create_operation_url = payload
        },
        set_use_waybill_url(state, payload) {
            state.use_waybill_url = payload
        },
        set_fetch_customers_url(state, payload) {
            state.fetch_customers_url = payload
        },
        set_fetch_converters_url(state, payload) {
            state.fetch_converters_url = payload
        },
        set_validate_waybill_url(state, payload) {
            state.validate_waybill_url = payload
        },
        set_requester_node(state, payload) {
            state.requester_node = payload
        },
        set_requester_contract(state, payload) {
            state.requester_contract = payload
        },
        set_customers(state, payload) {
            state.customers = payload
        },
        set_conversions(state, payload) {
            state.conversions = payload
        },
        set_converters(state, payload) {
            state.converters = payload
        },
        set_waybill_raw_datas(state, payload) {
            state.waybill_raw_datas = payload
        },
        set_waybill_processed_datas(state, payload) {
            state.waybill_processed_datas = payload
        },
        set_receivers(state, payload) {
            state.receivers = payload
        },
        set_current_converter(state, payload) {
            state.current_converter = payload
        },
        set_operator_node(state, payload) {
            state.operator_node = payload
        },
        init(state, payload) {
            state.customers = []
            state.requester_node = null
            state.requester_contract = null
            state.operator_node = {}
            state.waybill_raw_datas = []
            state.waybill_processed_datas = []
            state.receivers = []
            state.converters = []
            state.current_converter = null
            state.conversions = []
            state.open_file_url = null
            state.file_upload_url = "https://air.formosaas.com/api/v1/:app_id/cloud/:access_token/:identity/bucket/:bucket_identity/upload"
            state.fetch_customers_url = null
            state.fetch_converters_url = null
            state.create_operation_url = null
            state.use_waybill_url = null
            state.validate_waybill_url = null
            state.validator = "standard"
        },
    }
}

export default store
